<template>
  <v-container>
    <v-form ref="form" v-model="validado">
      <v-row dense>
        <v-row dense class="align-center justify-space-between">
          <!-- Botón de regreso -->
          <v-col cols="auto">
            <v-btn icon @click="$router.go(-1)">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <!-- <v-btn class="cancel" @click="Cancelar"> Cancelar </v-btn> -->
            <!--  <form-meta
          :data="registro"
          :remove-commit="'removerPecuaria'"
          :record-id="registro.id"
          @removed="$router.go(-1)"
        /> -->
            <save-btn
              class="btn-oval"
              :record-status="registro.estatus"
              :loading="loading"
              @click="antesDeGuardar"
            />
          </v-col>
        </v-row>
        <v-col cols="12">
          <span style="font-size: 30px">🐔</span>
          <div style="text-align: center" class="text-h4">
            {{
              nuevoAvicola
                ? 'Crea Nueva Producción Avicola'
                : 'Producción y Venta Avicola'
            }}
          </div>
        </v-col>
        <v-col cols="12">
          <div class="text-h7">
            Busca o agrega por Galera o Corral la Producción Avícola
          </div>
        </v-col>
        <!-- Criterios de búsqueda -->
        <v-col cols="12">
          <v-select
            ref="fincaSelect"
            v-model="registro.id_finca"
            :no-data-text="$vuetify.noDataText"
            :rules="[r.required]"
            :items="fincas"
            item-text="nombre"
            item-value="id"
            label="Finca *"
            outlined
            :disabled="busquedaFin"
            @input="onFincaChange()"
          >
            <template slot="item" slot-scope="{ item }">
              <finca-select-item :item="item" />
            </template>
          </v-select>
        </v-col>
        <v-col cols="12">
          <div class="d-flex justify-end">
            <modal-parcela />
          </div>
        </v-col>
        <v-col cols="12">
          <v-select
            ref="parcelaSelect"
            v-model="registro.id_parcela"
            :no-data-text="$vuetify.noDataText"
            clearable
            outlined
            :rules="[r.required]"
            :items="parcelasPorId(registro.id_finca)"
            item-value="id"
            item-text="nombre"
            label="Nombre del Gallinero, Galera, Nave o Corral *"
            :disabled="busquedaFin"
            @input="onParcelaChange()"
          />
        </v-col>
        <!-- <v-col cols="6">
          <v-text-field
            v-model.number="registro.ciclo"
            :rules="[r.required, r.int, r.min_num(1), r.max_num(9)]"
            label="Ciclo*"
            outlined
            @input="debounceBuscarRegistroExistente"
          />
        </v-col> -->
        <v-col cols="12">
          <div class="font-weight-medium grey--text text--darken-2">
            Fecha que Inicio la producción de este Grupo: Ejemplo: 2025-01-30
          </div>
        </v-col>
        <v-row align="center"> </v-row>
        <v-col cols="9">
          <v-combobox
            ref="fechaInicio"
            v-model="registro.fecha"
            :items="fechasSugeridas"
            label="Fecha que Inicio este Grupo *"
            range-type="production"
            :rules="[r.required]"
            :date.sync="registro.fecha"
            placeholder="aaaa-mm-dd"
            outlined
            :disabled="busquedaFin"
            @change="validarFecha"
          >
          </v-combobox>
          <p v-if="errorin" style="color: red">{{ errorin }}</p>
        </v-col>
        <!-- <v-col cols="2" class="d-flex align-center">
          <v-icon
            @mousedown.prevent="onFechaChange"
            color="primary"
            style="cursor: pointer; font-size: 35px"
          >
            mdi-magnify
          </v-icon> -->

        <v-col cols="2" class="d-flex align-center">
          <v-btn
            color="primary"
            block
            @mousedown.prevent="onFechaChange"
          >
            Siguiente
          </v-btn>
        </v-col>

        <!--  <v-col cols="4">
          <v-text-field
            v-model="registro.fecha_fin"
            label="Fecha Final"
            outlined
            placeholder="aaaa-mm-dd"
            @change="handleFechaChange"
          >
          </v-text-field>
          <p v-if="errorhas" style="color: red">{{ errorhas }}</p>
        </v-col> -->
        <!-- <v-col cols="4">
          <v-text-field
            v-model="registro.rendimiento_esperado"
            label="Rendimiento Esperado (%)"
            outlined
          />
        </v-col> -->
        <!-- Mensaje de estado de búsqueda -->
        <v-col v-if="mensajeBusqueda" cols="12">
          <v-alert
            :type="tipoMensaje"
            :value="true"
            dismissible
            @input="limpiarMensaje"
          >
            {{ mensajeBusqueda }}
          </v-alert>
        </v-col>

        <!-- Indicador de carga -->
        <v-col v-if="buscandoRegistro && !nuevoAvicola" cols="12">
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
          <div class="text-center text-body-2 mt-2">
            Buscando registro existente...
          </div>
        </v-col>

        <!-- {{actividad_pecuaria}} -->
        <!--  <v-col cols="5">
          <v-select v-model="registro.id_actividad_pecuaria" :no-data-text="$vuetify.noDataText" :rules="[r.required]"
            :items="rubros_filtrados" item-text="descripcion" item-value="id" label="Especie*" outlined
            @input="debounceBuscarRegistroExistente">
            <template v-slot:selection="props">
              <div v-text="props.item[props.parent.$props.itemText]" />
            </template>
          </v-select>
        </v-col> -->
        <!-- <v-col cols="6">
          <modal-establecimiento />
          <v-select
            v-model="registro.id_establecimiento"
            :no-data-text="$vuetify.noDataText"
            clearable
            outlined
            :items="establecimientosPorId(registro.id_finca)"
            item-value="id"
            item-text="rua"
            label="RUA"
          ></v-select>
        </v-col> -->

        <!--   <v-col cols="6">
          <v-text-field
            v-model="registro.fecha_fin"
            label="Fecha Final"
            outlined
            placeholder="yyyy-mm-dd"
            @change="handleFechaChange"
          >
          </v-text-field>
          <p v-if="errorhas" style="color: red">{{ errorhas }}</p>
        </v-col> -->
      </v-row>
      <!-- <v-col cols="3">
          <v-text-field v-model="registro.produccion" label="Producción*" outlined>
            <template v-slot:append>
              <unit-picker :group="`to_${guessUnit(registro.id_actividad_pecuaria)}`"
                @transform="registro.produccion = $event" />
            </template>
            <template v-slot:append-outer>
            </template>
          </v-text-field>
        </v-col> -->
      <!-- Campo para tipo de sistema -->
      <!--  <v-col cols="3">
      <v-select
        label="Tipo de Sistema"
        outlined
      />
    </v-col> -->
      <!-- Campo para rendimiento esperado -->
      <!-- <v-col cols="4">
          <v-text-field
            v-model="registro.rendimiento_esperado"
            label="Rendimiento Esperado (%)"
            outlined
          />
        </v-col> -->

      <!-- AQUI botones de entrada, engorde, produccion y venta-->
      <template v-if="nuevoAvicola || registro.id">
        <v-row align="center" justify="space-around">
          <v-col cols="4" class="d-flex justify-center">
            <v-btn
              :color="activeTab === 'ingreso' ? 'green darken-3' : 'primary'"
              class="white--text px-1"
              @click="pmostrarInventario()"
            >
              <span style="font-size: 25px">🐥</span>
              1.Ingreso
            </v-btn>
          </v-col>
          <v-col cols="4" class="d-flex justify-center">
            <v-btn
              :color="activeTab === 'engorde' ? 'green darken-3' : 'primary'"
              class="white--text px-1"
              @click="pmostrarEngorde()"
            >
              <span style="font-size: 25px">🐔</span>
              2.Engorde
            </v-btn>
          </v-col>
          <!--  <v-col cols="6" sm="3" md="3">
          <v-btn
          color="success"
          class="w-100"
          @click="
          mostrarProduccion = !mostrarProduccion
          if (mostrarProduccion) {
            mostrarInventario = false
            mostrarEngorde = false
            mostrarVenta = false
            }"
            >
            <v-icon left>mdi-eye</v-icon>
            Producción
          </v-btn>
        </v-col> -->
          <v-col cols="4" class="d-flex justify-center">
            <v-btn
              :color="activeTab === 'venta' ? 'green darken-3' : 'primary'"
              class="white--text px-1"
              @click="pmostrarVenta()"
            >
              <span style="font-size: 30px">🛒</span>
              3.Venta
            </v-btn>
          </v-col>
        </v-row>
        <!-- listado dinámico de producciones pecuarias -->

        <!-- Situación de desastre -->
        <!-- <v-col cols="12">
          <v-btn depressed block class="primary--text" @click="agregarDesastre">
            <v-icon left>mdi-plus</v-icon>
            Agregar situación de desastre
          </v-btn>
        </v-col>
        <situacion-de-desastre
          v-for="(desastre, index) in registro.desastres"
          :key="desastre.id_trxdano"
          :form="registro.desastres[index]"
          :modulo="'AVICOLA'"
          @eliminar="eliminarDesastre(index)"
        /> -->
        <!--****************** CUADRO PARA VER EL INVENTARIO DE LA FINCA  ************************** -->
        <v-row class="text-left" v-if="mostrarInventario">
          <v-col cols="6">
            <v-btn
              block
              rounded
              class="primary--text"
              @click="agregarProduccionYEditar"
            >
              <v-icon left>mdi-plus</v-icon>
              Agrega Nuevo Ingreso
            </v-btn>
          </v-col>
          <v-col
            cols="12"
            v-if="indexEdicion !== null && registro.producciones.length > 0"
          >
            <v-card outlined class="pa-4 mb-4">
              <v-row>
                <v-col cols="12" md="3">
                  <v-select
                    v-model="
                      registro.producciones[indexEdicion].id_actividad_pecuaria
                    "
                    :no-data-text="$vuetify.noDataText"
                    :rules="[r.required]"
                    :items="actividad_avicola"
                    item-text="descripcion"
                    item-value="id"
                    label="Rubro *"
                    ref="tipoavicolaSelect"
                    outlined
                    @input="handleActividadChange(indexEdicion)"
                    @change="
                      () => {
                        if (
                          isDiagnosticoPecuario(
                            registro.producciones[indexEdicion]
                              .id_actividad_pecuaria
                          )
                        ) {
                          registro.producciones[indexEdicion].cantidad = null
                          registro.producciones[indexEdicion].produccion = 0
                        } else {
                          registro.producciones[indexEdicion].haespecia = null
                        }
                      }
                    "
                  >
                    <template v-slot:selection="props">
                      <div v-text="props.item[props.parent.$props.itemText]" />
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="registro.producciones[indexEdicion].cantidad"
                    :rules="[r.required]"
                    label="Cantidad *"
                    outlined
                  />
                </v-col>
                 <v-col cols="12" md="6">
                  <v-text-field
                    v-model.number="
                      registro.producciones[indexEdicion].produccion
                    "
                    :rules="[r.required, r.float, r.min_num(0)]"
                    label="Peso Inicial*"
                    outlined
                  >
                    <template v-slot:append>
                      <unit-picker
                        @transform="
                          registro.producciones[indexEdicion].produccion =
                            $event
                        "
                      />
                    </template>
                  </v-text-field>
                </v-col>
                 <v-col cols="12" md="3">
                  <v-text-field
                    v-model="registro.producciones[indexEdicion].identirubro"
                    label="Identificación del Lote"
                    outlined
                  />
                </v-col>
                Ejemplo: 2025-01-30
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="registro.producciones[indexEdicion].fechanac"
                    label="Fecha de nacimiento aproximada "
                    placeholder="aaaa-mm-dd"
                    outlined
                    :error="!!errorn[`fechanac_${indexEdicion}`]"
                    :error-messages="errorn[`fechanac_${indexEdicion}`] || ''"
                    @change="validarFechaNac"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    v-model="registro.producciones[indexEdicion].sexo"
                    :items="sexoOptions"
                    item-text="text"
                    item-value="value"
                    outlined
                    label="Sexo"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="registro.producciones[indexEdicion].raza"
                    outlined
                    label="Raza"
                  />
                </v-col>
               
                <v-col cols="12" md="6">
                  <v-select
                    v-model="registro.producciones[indexEdicion].color"
                    :items="color"
                    label="Color"
                    outlined
                  />
                </v-col>
                <!--   <v-col cols="6" md="6">
                  <v-text-field
                    v-model="registro.producciones[indexEdicion].fecha_salida"
                    outlined
                    label="Salida"
                    :date.sync="
                      registro.producciones[indexEdicion].fecha_salida
                    "
                    placeholder="aaaa-dd-mm"
                    :error-messages="errors[`salida_${indexEdicion}`] || []"
                    @change="validarFechaSalida(indexEdicion)"
                  />
                </v-col>
                <v-col cols="6" md="6">
                  <v-select
                    v-model="registro.producciones[indexEdicion].tipo_salida"
                    :items="tipoSalidaOptions"
                    item-text="text"
                    item-value="value"
                    outlined
                    label="Tipo de Salida"
                  />
                </v-col> -->
                <v-col cols="6" md="6" class="d-flex align-end">
                  <v-btn color="primary" @click="guardarEntrada">
                    Siguiente
                  </v-btn>
                </v-col>
                <v-col cols="6" md="3" class="d-flex">
                  <v-btn icon @click="eliminarFilaProduccion(indexEdicion)">
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <!-- listado de producciones (entradas) -->
          <v-col
            cols="12"
            v-for="(item, index) in registro.producciones"
            :key="index"
          >
            <v-card
              outlined
              class="pa-0 custom-border"
              :style="
                index === indexEdicion
                  ? 'border: 2.8px solid #ff9800;'
                  : 'border: 2.8px solid #4caf50;'
              "
              @click="editarProduccion(index)"
            >
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">
                    <strong>Animal:</strong>
                    {{ descripcionActividad(item.id_actividad_pecuaria) || '' }}
                    - Sexo: {{ sexoTexto(registro.producciones[index].sexo) }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    Peso: {{ item.produccion }} kg - Cantidad:
                    {{ item.cantidad }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-right">
                    Fecha de Nacimiento: {{ item.fechanac || '' }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>

        <!-- Contenedor con scroll horizontal y vertical -->
        <!-- <v-col cols="12">
          <div
            style="
              overflow-y: auto;
              max-height: 400px;
              width: 100%;
              border: 1px solid #ccc;
            "
          >
            <table class="custom-table">
              <thead>
                <tr>
                  <th v-for="header in headers_produccion" :key="header.value">
                    {{ header.text }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in registro.producciones"
                  :key="`producciones-${index}`"
                >
                  <td>
                    <v-btn
                      small
                      color="primary"
                      @click="mostrarFormularioEdicion(index)"
                    >
                      Ver
                    </v-btn>
                  </td>

                  <td>
                    <v-select
                      v-model="item.id_actividad_pecuaria"
                      :no-data-text="$vuetify.noDataText"
                      :rules="[r.required]"
                      :items="actividad_pecuaria"
                      item-text="descripcion"
                      item-value="id"
                      label="Rubro*"
                      style="width: 200px"
                      @input="handleActividadChange(index)"
                      @change="
                        () => {
                          if (
                            isDiagnosticoPecuario(item.id_actividad_pecuaria)
                          ) {
                            item.cantidad = null
                            item.produccion = 0
                          } else {
                            item.haespecia = null
                          }
                        }
                      "
                    >
                      <template v-slot:selection="props">
                        <div
                          v-text="props.item[props.parent.$props.itemText]"
                        />
                      </template>
                    </v-select>
                  </td>
                  <td>
                    <v-text-field
                      v-model="item.identirubro"
                      placeholder="Código"
                      outlined
                    />
                  </td>

                  <td>
                    <v-text-field
                      v-model="item.cantidad"
                      :rules="[r.float, r.min_num(0), r.max_num(10000000)]"
                      placeholder="Cantidad"
                      style="width: 100px"
                      outlined
                    />
                  </td>
                  <td>
                    <v-text-field
                      v-model.number="item.produccion"
                      :rules="[r.required, r.float, r.min_num(0)]"
                      label="Peso*"
                      outlined
                      style="width: 125px"
                    >
                    </v-text-field>
                  </td>

                  <td>
                    <v-text-field style="width: 10px">
                      <template v-slot:append>
                        <unit-picker
                          :group="`to_${guessUnit(item.id_actividad_pecuaria)}`"
                          @transform="item.produccion = $event"
                        />
                      </template>
                    </v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      v-model="item.fechanac"
                      label="Fecha de nacimiento"
                      outlined
                      type="date"
                      placeholder="yyyy-mm-dd"
                    />
                  </td>

                  <td>
                    <v-select
                      v-model="item.color"
                      style="width: 100px"
                      :items="[
                        'Blanco',
                        'Negro',
                        'Rojo',
                        'Café o Marrón',
                        'Gris',
                        'Rubio o Amarillento',
                        'Manchado (negro y blanco)',
                        'Overo (rojo y blanco)',
                        'Pintado (blanco y marrón o con negro)',
                        'Dorado o Bayo',
                        'Atigrado (franjas oscuras y claras)',
                        'Cintillo Blanco (cara blanca y cuerpo negro)',
                        'Plateado',
                      ]"
                      outlined
                      label="Color"
                      placeholder="Color"
                      dense
                    />
                  </td>
                  <td>
                    <v-text-field
                      v-model="item.raza"
                      placeholder="Raza"
                      outlined
                      style="width: 120px"
                    />
                  </td> -->

        <!-- Se omplementara el pasto en otro ModalEstablecimiento -->
        <!--  <v-col
                  v-show="
                    isDiagnosticoPecuario(produccion.id_actividad_pecuaria)
                  "
                  cols="6"
                  md="4"
                >
                  <v-text-field
                    v-model.number="produccion.haespecia"
                    :rules="[r.float, r.min_num(0.1), r.max_num(10000000)]"
                    label="Superficie para pasto"
                    suffix="Ha"
                    outlined
                  />
                </v-col> 
                  <td>
                    <span>{{ item.ugsumespecie }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-col>
         <v-snackbar v-model="snackbarVisible" color="error" timeout="3000">
        {{ snackbarMessage }}
        <v-btn color="white" text @click="snackbarVisible = false"
          >Cerrar</v-btn
        >
      </v-snackbar>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>-->
        <!-- FALTA <v-col v-if="pastoSurfaceOverflow" cols="12">
          <n-text error :fix-required="pastoSurfaceOverflow"
            >La superficie acumulada del pasto en la producción excede la
            superficie para pasto que coloco.</n-text
          >
    </v-col> -->
        <!--          <v-col
            v-if="!isDiagnosticoPecuario(produccion.id_actividad_pecuaria)"
            cols="6"
            md="2"
          >
            <v-text-field
              v-model.number="produccion.cantidad"
              :rules="[r.float, r.min_num(0), r.max_num(10000000)]"
              label="Cantidad"
              suffix="#"
              outlined
            />
          </v-col>
          <v-col cols="6" md="2">
            <v-text-field
              disabled
              :value="produccion.ugsumespecie"
              :rules="[r.required, r.float, r.min_num(0), r.max_num(10000000)]"
              label="ug"
              outlined
            />
          </v-col> -->

        <!-- Tabla de Engorde - Avances creados desde Producciones -->
        <!--  <v-row v-if="mostrarEngorde" justify="center" class="mx-0">
        <v-col cols="12" class="px-0">
          <div class="text-h5 font-weight-bold">Etapas y Engorde</div>
          <div class="text-h6 black--text">
            Agregue el engorde (peso) de cada animal o del grupo y cada etapa de
            producción
          </div>
        </v-col> 
        <v-col cols="12" class="px-0">
          <div class="text-h6 black--text">
            Agregue el engorde (peso) de cada animal o del grupo y cada etapa de
            producción
          </div>
        </v-col> 

        <v-col cols="12">
          <div
            style="
              overflow-x: auto;
              overflow-y: auto;
              max-height: 400px;
              width: 100%;
              border: 1px solid #ccc;
            "
          >
            <table class="custom-table1">
              <thead>
                <tr>
                  <th v-for="headera in headers_engorde" :key="headera.value">
                    {{ headera.text }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(fila, index) in registro.engorde" :key="index">
                  <td>
                    <v-autocomplete
                      v-model="fila.id_actividad_pecuaria"
                      :items="actividad_pecuaria"
                      item-text="descripcion"
                      item-value="id"
                      label="Tipo de Animal*"
                      style="width: 200px"
                    />
                  </td>

                  <td>
                    <v-text-field v-model="fila.identirubro" outlined />
                  </td>

                  <td>
                    <v-text-field
                      v-model="fila.fecha_medicion"
                      type="date"
                      outlined
                    />
                  </td>

                  <td>
                    <v-select
                      v-model="fila.etapa_anterior"
                      :items="estado_pecuario"
                      item-text="estado_productivo"
                      item-value="estado_productivo"
                      outlined
                    />
                  </td>

                  <td>
                    <v-select
                      v-model="fila.etapa_actual"
                      :items="estado_pecuario"
                      item-text="estado_productivo"
                      item-value="estado_productivo"
                      outlined
                    />
                  </td>

                  <td>
                    <v-text-field
                      v-model="fila.cantidad"
                      label="Cantidad"
                      style="width: 100px"
                      outlined
                    />
                  </td>

                  <td>
                    <v-text-field
                      v-model="fila.medicion"
                      label="Peso"
                      style="width: 100px"
                      outlined
                    />
                  </td>

                  <td>
                    <v-select
                      v-model="fila.unidad"
                      :items="unidad_medida"
                      item-text="descripcion"
                      item-value="id"
                      label="Unidad"
                      style="width: 100px"
                      outlined
                    />
                  </td>

                  <td>
                    <v-btn icon @click="eliminarFila(index)">
                      <v-icon color="red">mdi-delete</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-col>
      
      <tr class="button-row">
        <td colspan="100%">
          <v-btn
            depressed
            block
            class="primary--text custom-button"
            style="margin-top: 10px"
            @click="handleAddRowAndOtherAction()"
          >
            <v-icon left>mdi-plus</v-icon>
            Agregar Engorde
          </v-btn>
        </td>
      </tr>
      </v-row> -->
        <!--  </v-col> -->
        <!-- <button
                    @click="handleAddRowAndOtherAction()"
                    class="btn btn-primary"
                  >
                    Agregar Engorde
            </button> -->
        <!-- </v-row> -->
        <!-- listado dinámico de destinos -->
        <!--  <v-col cols="12">
          <div class="text-h6">VENTAS Y CÁLCULOS DE COMPETITIVIDAD</div>
        </v-col> -->
        <!-- Tabla de Engorde - Avances creados desde Producciones -->
        <v-row v-if="mostrarEngorde" class="mx-0">
          <!-- Botón Agregar engorde -->
          <v-col cols="4">
            <v-btn
              block
              rounded
              class="primary--text custom-button"
              style="margin-top: 10px"
              @click="AgregarEngorde()"
            >
              <v-icon left>mdi-plus</v-icon>
              Agregar Engorde
            </v-btn>
          </v-col>
          <!-- AQUI Formulario engorde -->
          <v-col cols="12" v-if="indexEdicionEngorde !== null">
            <v-card outlined class="pa-4 mb-4">
              <v-row>
                <v-col cols="12" md="3">
                  <v-autocomplete
                    v-model="
                      registro.reg_avicola[indexEdicionEngorde]
                        .id_actividad_pecuaria
                    "
                    :items="actividad_avicola"
                    item-text="descripcion"
                    item-value="id"
                    label="Rubro*"
                    outlined
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="
                      registro.reg_avicola[indexEdicionEngorde].fecha_medicion
                    "
                    :rules="[r.required]"
                    placeholder="aaaa-mm-dd"
                    label="Fecha que ocurre"
                    outlined
                    @input="validarfechareg()"
                  />
                  <p v-if="errorreg" style="color: red">{{ errorreg }}</p>
                </v-col>

                <!--  <v-col cols="12" md="3">
                  <v-select
                    v-model="registro.reg_avicola[indexEdicionEngorde].sexo"
                    :items="sexoOptions"
                    item-text="text"
                    item-value="value"
                    outlined
                    label="Sexo"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="registro.reg_avicola[indexEdicionEngorde].raza"
                    outlined
                    label="Raza"
                  />
                </v-col> -->
                <!-- <v-col cols="12" md="3">
                  <v-select
                  v-model="registro.engorde[indexEdicionEngorde].etapa_anterior"
                  :items="estado_pecuario"
                  item-text="estado_productivo"
                  item-value="estado_productivo"
                  label="Etapa Productiva Anterior"
                  outlined
                  />
                </v-col> -->
                <!-- <v-col cols="12" md="3">
                  <v-select
                  v-model="registro.engorde[indexEdicionEngorde].etapa_actual"
                  :items="estado_pecuario"
                  item-text="estado_productivo"
                  item-value="estado_productivo"
                  label="Etapa Productiva Actual"
                  outlined
                  />
                </v-col> -->
                <!-- <v-col cols="12" md="3">
                  <v-text-field
                  v-model.number="registro.engorde[indexEdicionEngorde].cantidad"
                  label="Cantidad"
                  outlined
                  />
                </v-col> -->
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model.number="
                      registro.reg_avicola[indexEdicionEngorde].medicion
                    "
                    label="Peso"
                    outlined
                  >
                    <template v-slot:append>
                      <unit-picker
                        @transform="
                          registro.reg_avicola[indexEdicionEngorde].medicion =
                            $event
                        "
                      />
                    </template>
                  </v-text-field>
                </v-col>
                <!-- <v-col cols="6" md="3">
                  <v-select
                    v-model="registro.reg_avicola[indexEdicionEngorde].unidad"
                    :items="unidad_medida"
                    item-text="descripcion"
                    item-value="id"
                    label="Unidad"
                    outlined
                  />
                </v-col> -->
                <v-col cols="6" md="3" class="d-flex align-end">
                  <v-btn color="primary" @click="guardarEngorde">
                    Siguiente
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn icon @click="eliminarFilaEngorde(indexEdicionEngorde)">
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <!-- listado de engorde -->
          <v-col
            cols="12"
            v-for="(fila, index) in registro.reg_avicola"
            :key="index"
          >
            <v-card
              outlined
              class="pa-0 custom-border"
              :style="
                index === indexEdicionEngorde
                  ? 'border: 2.8px solid #ff9800;'
                  : 'border: 2.8px solid #4caf50;'
              "
              @click="editarEngorde(index)"
            >
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">
                    <strong>Rubro:</strong>
                    {{ descripcionActividad(fila.id_actividad_pecuaria) || '' }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    Peso: {{ fila.medicion }}
                    {{ descripcionUnidad(fila.unidad) }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-right">
                    Fecha: {{ fila.fecha_medicion }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>

        <div v-if="mostrarVenta" style="margin-top: 30px">
          <destino
            :destinos="registro.destinos"
            :producciones="registro.producciones"
            :listado-destinos="destino"
            :rubros="actividad_avicola"
            :tabla-produccion-id-rubro="tabla_produccion_id_rubro"
          />
        </div>

        <div v-if="mostrarobserva">
          <v-col cols="12">
            <div class="text-h6">Tareas Pendientes y Observaciones</div>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="registro.observacion"
              :rules="[r.max(1000)]"
              label="Tarea_Pendiente, Fecha, Observación"
              auto-grow
              outlined
              rows="1"
            ></v-textarea>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model.number="registro.superficie_para_pasto"
              :rules="[r.required, r.float, () => alertSurfaceOverflow]"
              label="Superficie de pasto*"
              suffix="Ha"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model.number="registro.superficie_para_hacerla_pasto"
              :rules="[r.required, r.float, () => alertSurfaceOverflow]"
              label="Superficie para hacerla pasto*"
              suffix="Ha"
              outlined
            ></v-text-field>
          </v-col>
        </div>
        <!-- Campo para ley de beneficio -->
        <!--  <v-col cols="12">
        <v-select
          v-model="registro.ley_beneficio"
          label="Programa"
          :items="programa_gobierno"
          item-text="programa"
          item-value="programa"
          outlined
        />
      </v-col> -->
      </template>

      <v-snackbar v-model="snackbarVisible" color="error">
        {{ snackbarMessage }}
        <v-btn color="white" text @click="snackbarVisible = false"
          >Cerrar</v-btn
        >
      </v-snackbar>
      <!-- </v-row> -->
    </v-form>

    <registro-existente
      :title="'La producción ya existe'"
      :description="'Los datos colocados corresponden a una producción existente, desea cargar la información de esta producción?'"
      :loading="modal_registro_existe_loading"
      :modal="modal_registro_existe"
      @cerrarModal="cerrarModalRegistroExistente"
      @cargarDatos="cargarRegistroExistente"
    />
  </v-container>
</template>

<script>
import Form from '@/components/js/Form'
import { mapState, mapGetters } from 'vuex'
import { clona } from '../../utilidades'
import {
  produccion_avicola,
  formulario_avicola,
  danotrx,
  reg_avicola,
} from '../../modelos'
import FincaSelectItem from '../../components/FincaSelectItem.vue'
import ModalParcela from '../../components/ModalParcela.vue'
import debounce from 'lodash.debounce'

//import ModalEstablecimiento from '../../components/ModalEstablecimiento.vue'
//import SituacionDeDesastre from '../../components/form/SituacionDeDesastre.vue'

export default {
  name: 'Avicola',
  components: {
    Destino: () => import('@/components/form/Destino.vue'),
    FincaSelectItem,
    ModalParcela,
    //ModalEstablecimiento,
    //SituacionDeDesastre,
  },
  extends: Form,
  data() {
    return {
      activeTab: 'ingreso',
      esEditable: true,
      tipoSalidaOptions: [
        { text: 'Al matadero', value: 'Al matadero' },
        { text: 'AutoConsumo', value: 'AutoConsumo' },
        { text: 'Muerte', value: 'Muerte' },
        { text: 'Para comercio', value: 'Para comercio' },
        { text: 'Pérdida', value: 'Pérdida' },
        { text: 'Salida hacia otra finca', value: 'Salida hacia otra finca' },
      ],
      indexEdicionEngorde: null,
      mensajeBusqueda: '',
      busquedaFin: false,
      buscandoRegistro: false,
      indexEdicion: null,
      nuevoAvicola: false,
      mostrarFormularioEditable: false,
      filaEdicion: null,
      errorn: {},
      //AQUI
      mostrarInventario: true,
      mostrarProduccion: false,
      mostrarEngorde: false,
      mostrarVenta: false,
      mostrarobserva: false,
      filaVisibleIndex: null,
      color: [
        'Blanco',
        'Negro',
        'Rojo',
        'Café o Marrón',
        'Gris',
        'Rubio o Amarillento',
        'Manchado (negro y blanco)',
        'Overo (rojo y blanco)',
        'Pintado (blanco y marrón o con negro)',
        'Dorado o Bayo',
        'Atigrado (franjas oscuras y claras)',
        'Cintillo Blanco (cara blanca y cuerpo negro)',
        'Plateado',
      ],
      filaEdicion: null,
      //
      llaveid_pecuario: '',
      llaveid_actividad_pecuaria: '',
      llaveidentirubro: '',
      errorin: '',
      errors: {},
      errorhas: '',
      errorreg: '',
      fecha: '',
      fecha_fin: '',
      año: '',
      mes: '',
      duracionProduccion: null,
      estaditi: '',
      tabla_principal_id: 'id',
      tabla_produccion_id_rubro: 'id_actividad_pecuaria',
      ruta_registros: 'avicolas',
      ruta_registro: 'avicola',
      nombre_registros_en_state: 'avicolas',
      nombre_registro_en_state: 'avicola',
      dispatch_get_registro: 'getAvicola',
      dispatch_guardar_registro: 'guardarAvicola',
      registro: clona(formulario_avicola),
      registro_producciones: clona(produccion_avicola),
      reg_avicola: clona(reg_avicola),
      pastoSurfaceOverflow: false,
      filtro: {
        id_actividad_pecuaria: null,
        identirubro: null,
      },
      //reg_avicola:[],

      engordeSeleccionado: [],
      identirubroSeleccionado: null, // Mantendrá el identirubro actualmente seleccionado
      idActividadSeleccionada: null, // ID de la actividad seleccionada
      // registrosSeleccionados: [],
      snackbarVisible: false,
      snackbarMessage: '',
      /* engorde: [
        {
          id_actividad_pecuaria: '',
          identirubro: '',
          fecha_medicion: '',
          medicion: '',
          cantidad: 0,
          id_medicion: '',
          unidad: '',
          etapa_anterior: '',
          etapa_actual: '',
        },
      ], */
      headers_produccion: [
        { text: 'Rubro', value: 'id_actividad_pecuaria', align: 'center' },
        { text: 'ID o Lote', value: 'identirubro', align: 'center' },
        { text: 'Cantidad', value: 'cantidad', align: 'center' },
        { text: 'Peso', value: 'produccion', align: 'center' },
        { text: 'Unidad*', value: 'unidad', align: 'center' },
        // { text: 'Nacimiento Aproximado', value: 'fechanac', align: 'center' },
        //{ text: 'Color', value: 'color', align: 'center' },
        // { text: 'Raza', value: 'raza', align: 'center' },
        //{ text: 'UGM', value: 'ugsumespecie', align: 'center' },
        { text: 'Eliminar Fila', value: 'acciones', align: 'center' },
      ],
      headers_inventario: [
        { text: 'Rubro', value: 'id_actividad_pecuaria', align: 'center' },
        { text: 'Fecha', value: 'fecha', align: 'center' },
        { text: 'ID o Lote', value: 'identirubro', align: 'center' },
        { text: 'Cantidad', value: 'cantidad', align: 'center' },
        { text: 'Nacimiento Aproximado', value: 'fechanac', align: 'center' },
        { text: 'Sexo', value: 'sexo', align: 'center' },
        { text: 'Raza', value: 'raza', align: 'center' },
        //{ text: 'Color', value: 'color', align: 'center' },
        { text: 'Eliminar Fila', value: 'acciones', align: 'center' },
      ],
      dialogoAbierto: false,
      headers_engorde: [
        { text: 'Rubro', value: 'id_actividad_pecuaria' },
        { text: 'ID o Lote', value: 'identirubro' },
        { text: 'Fecha de salida', value: 'fecha_medicion' },
        //{ text: 'Etapa Productiva Anterior', value: 'etapa_anterior' },
        //{ text: 'Etapa Productiva Actual', value: 'etapa_actual' },
        { text: 'Cantidad', value: 'cantidad' },
        { text: 'Peso Promedio', value: 'medicion' },
        { text: 'Unidad', value: 'unidad' },
        { text: 'Sexo', value: 'unidad' },
        { text: 'Eliminar Fila' },
      ],
      sexoOptions: [
        { text: 'HEMBRA', value: '1' },
        { text: 'MACHO', value: '2' },
        { text: 'NINGUNO', value: null },
      ],
    }
  },

  computed: {
    ...mapGetters('registros', [
      'establecimientosPorId',
      'parcelasPorId',
      'getMatchingRecords',
      'productor_actual',
    ]),
    ...mapState('listados', [
      'actividad_avicola',
      'actividad_pecuaria',
      'programa_gobierno',
      'estado_productivos',
      'unidad_medida',
      'tipo_parcela',
    ]),
    ...mapGetters('listados', ['unidadMedidaPorId']),
    rubros_filtrados() {
      const selected = this.registro.producciones.map(
        (v) => v[this.tabla_produccion_id_rubro]
      )
      return this.actividad_avicola.map((v) => ({
        ...v,
        /* disabled: selected.includes(v.id), */
        disabled: false,
      }))
    },
    fechasSugeridas() {
      const avicolas = this.$store.state.registros.avicolas
      if (!this.registro.id_finca || !this.registro.id_parcela) return []

      const fechas = Object.values(avicolas)
        .filter(
          (a) =>
            a.id_finca === this.registro.id_finca &&
            a.id_parcela === this.registro.id_parcela
        )
        .map((a) => a.fecha)

      return [...new Set(fechas)].sort((a, b) => b.localeCompare(a))
    },
    sexoTexto() {
      return (sexoValue) => {
        const opcion = this.sexoOptions.find((item) => item.value == sexoValue)
        return opcion ? opcion.text : 'NINGUNO'
      }
    },

    años() {
      const añoActual = new Date().getFullYear()
      const años = []

      // Agregar los últimos 10 años en formato "YYYY - YYYY"
      for (let i = 0; i < 10; i++) {
        const añoInicio = añoActual - i
        const añoFin = añoInicio + 1
        años.push({
          texto: `${añoInicio} - ${añoFin}`,
          valor: añoInicio, // o puedes usar un objeto con ambos años
        })
      }

      return años
    },

    alertSurfaceOverflow() {
      const id = this.registro.id
      const id_finca = this.registro.id_finca
      const year = (date) => new Date(date).getFullYear()
      const pecuarias = this.getMatchingRecords({
        recordName: 'pecuarias',
        matchValues: [
          { key: 'id_finca', value: id_finca },
          { key: 'ciclo', value: this.registro.ciclo },
        ],
        exceptIds: [id],
      })
      const fincas = this.getMatchingRecords({
        recordName: 'fincas',
        matchValues: [{ key: 'id', value: id_finca }],
      })
      const superficies_pecuarias_para_pasto = pecuarias
        .filter((p) => year(p.fecha) === year(this.registro.fecha))
        .map((p) => p.superficie_para_pasto)
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
      const superficies_pecuarias_para_hacerlas_pasto = pecuarias
        .filter((p) => year(p.fecha) === year(this.registro.fecha))
        .map((p) => p.superficie_para_hacerla_pasto)
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
      const overflow =
        superficies_pecuarias_para_pasto +
          superficies_pecuarias_para_hacerlas_pasto +
          parseFloat(this.registro.superficie_para_pasto) +
          parseFloat(this.registro.superficie_para_hacerla_pasto) >
        parseFloat(fincas?.[0]?.extension ?? 0)
      return (
        !overflow ||
        'La suma de las superficies para este año y finca exceden la superficie de la finca'
      )
    },
  },

  watch: {
    //  Observar la fecha de finalización para calcular la duración automáticamente
    'registro.fecha_fin': 'calcularDuracionProduccion',

    /* producciones: {
      handler(newProducciones) {
        if (newProducciones && newProducciones.length > 0) {
          // EN ENGORDE Filtra las filas vacías que no tienen un id_actividad_pecuaria
          const filasVacias = this.registro.reg_avicola.filter(
            (fila) => !fila.id_actividad_pecuaria
          )

          newProducciones.forEach((produccion) => {
            const filaVacia = filasVacias.shift() // Toma la primera fila vacía disponible

            if (filaVacia) {
              // Verifica que la fila tiene los datos necesarios antes de asignar los valores
              if (produccion.id_actividad_pecuaria) {
                // Actualiza la fila vacía con los datos de la nueva producción
                Object.assign(filaVacia, {
                  identirubro: produccion.identirubro || '0',
                  fecha_medicion:
                    produccion.fecha_medicion ||
                    new Date().toISOString().split('T')[0],
                  etapa_anterior: produccion.etapa_anterior || '',
                  etapa_actual: produccion.etapa_actual || '',
                  cantidad: produccion.cantidad || 0,
                  medicion: produccion.medicion || '',
                  id_medicion: produccion.id_medicion || '',
                  id_pecuario: produccion.id_pecuario || null,
                  id_actividad_pecuaria:
                    produccion.id_actividad_pecuaria || null,
                  ingreso_anual: produccion.ingreso_anual || 0,
                })
              } else {
                // Si no hay id_actividad_pecuaria, elimina la fila vacía para evitar errores
                const index = this.registro.reg_avicola.indexOf(filaVacia)
                if (index > 0) {
                  this.registro.reg_avicola.splice(index, 1)
                }
              }
            }
          })
        }
      },
    }, */

    'registro.superficie_para_pasto': {
      immediate: true,
      handler() {
        this.calculatePastoSurfaceAndWarn()
      },
    },

    'registro.producciones': {
      deep: true,
      immediate: true,
      handler() {
        this.convertirDatosSexo()
        this.calculatePastoSurfaceAndWarn()

        for (const [index, prod] of this.registro?.producciones?.entries()) {
          // calcula el ug para cada elemento de producción
          const isDiagnosticoPecuario = this.isDiagnosticoPecuario(
            prod.id_actividad_pecuaria
          )
          const rubro = this.getRubroById(prod.id_actividad_pecuaria)
          if (!rubro) {
            return ''
          }

          if (isDiagnosticoPecuario) {
            if (!isNaN(prod.haespecia) && !isNaN(rubro.ugequivalente)) {
              this.registro.producciones[index].ugsumespecie = (
                prod.haespecia * rubro.ugequivalente
              ).toFixed(2)
            } else {
              this.registro.producciones[index].ugsumespecie = 0
            }
          } else {
            if (!isNaN(prod.cantidad) && !isNaN(rubro.ugequivalente)) {
              this.registro.producciones[index].ugsumespecie = (
                prod.cantidad * rubro.ugequivalente
              ).toFixed(2)
            } else {
              this.registro.producciones[index].ugsumespecie = 0
            }
          }
        }
      },
    },
  },

  mounted() {
    this.$store.commit('ui/updateToolbar', 'Avicola')
    const id = this.obtenerIdDeRuta()
    if (id) {
      this.cargarRegistro(id)
      this.busquedaFin = true
      //aqui para que tenga un registro "ingreso" siempre que se cargue el registro
      /* this.agregarProduccionYEditar()
      this.AgregarEngorde() */
    } else {
      this.registro = clona(formulario_avicola)
      this.registro.producciones = []
      this.busquedaFin = false
      // Limpiar el arreglo de producciones
      //this.registro.producciones = []
      /* this.agregarProduccionYEditar()
       this.registro.reg_avicola = []
      this.AgregarEngorde() */
    }

    /*JUANDIEGO cuando se clonaba el registro se borraba el 
id del productor, solo habia que copiar y pegar la misma 
linea que se usa en mounted para asignarselo*/
    this.registro.id_productor = this.productor_actual

    if (!this.registro.ciclo) {
      this.registro.ciclo = 1
    }
    // Establece la fecha de inicio al cargar la página
    //this.inicializarProducciones()
  },

  methods: {
    cantidad_vendida_inversa() {
      let produccion = this.registro.produccion
      let vendido = this.registro.cantidad_vendida
      if (this.registro.unidad_produccion === 'lb') {
        produccion = produccion * this.lb_to_kg
      }
      if (this.registro.unidad_cantidad_vendida === 'lb') {
        vendido = vendido * this.lb_to_kg
      }
      return vendido > produccion
    },
    registroNoEncontrado() {
      this.mensajeBusqueda = 'No existe el registro. Creando Registro nuevo...'
      this.tipoMensaje = 'info'
      this.nuevoAvicola = true
      this.crearNuevoRegistro()
    },

    async crearNuevoRegistro() {
      const { id_finca, id_parcela, fecha } = this.registro

      if (this.$route.path !== '/ru/avicola') {
        await this.$router.push('/ru/avicola')
      }
      this.registro = clona(formulario_avicola)

      this.registro.id_productor = this.productor_actual

      this.registro.id_finca = id_finca
      this.registro.id_parcela = id_parcela
      this.registro.fecha = fecha
      this.registro.producciones = []
      this.indexEdicion = null
      this.esEditable = true
      this.busquedaFin = true
    },

    onFincaChange() {
      if (this.busquedaFin) return
      // Ejecutar la función original para cargar fincas/parcelas disponibles
      this.debounceBuscarRegistroExistente()
      // Ejecutar la función para buscar registro
      this.debounceBuscarRegistroPorCriterios()
    },

    onParcelaChange() {
      if (this.busquedaFin) return
      // Ejecutar la función original para cargar fincas/parcelas disponibles
      this.debounceBuscarRegistroExistente()
      // Ejecutar nuestra función para buscar registro por criterios
      this.debounceBuscarRegistroPorCriterios()
    },

    /* JUANDIEGO puse la funcion que sea async
le agregue esta seccion que es la que ejecuta la espera del siguiente click y revisa que el valor se haya actualizado
// 1) Forzar que el texto escrito quede en el modelo antes de validar
      if (
        cb &&
        cb.internalSearch != null &&
        cb.internalSearch !== this.registro.fecha
      ) {
        this.registro.fecha = cb.internalSearch.trim()
      }
      await this.$nextTick() // espera a que Vue actualice

y agregue esta validacion para que el formato este biene scrito
        if (!this.validarFecha()) {
        this.$store.commit('ui/setSnack', {
          text: 'Debe llenar Fecha con el formato correcto',
          color: 'error',
        })
        return
      }
JUANDIEGO */
    async onFechaChange() {
      // 1) Forzar que el texto escrito quede en el modelo antes de validar
      const cb = this.$refs.fechaInicio
      if (
        cb &&
        cb.internalSearch != null &&
        cb.internalSearch !== this.registro.fecha
      ) {
        this.registro.fecha = cb.internalSearch.trim()
      }
      await this.$nextTick() // espera a que Vue actualice

      // 2) Validar con el valor ya actualizado
      const camposValidos =
        this.$refs.fincaSelect.validate() &&
        this.$refs.parcelaSelect.validate() &&
        this.$refs.fechaInicio.validate()

      if (!camposValidos) {
        this.$store.commit('ui/setSnack', {
          text: 'Debe llenar Finca, Galera y Fecha antes de continuar',
          color: 'error',
        })
        return
      }

      if (!this.validarFecha()) {
        return
      }

      if (this.busquedaFin) return

      // 3) Ejecutar la búsqueda con valores frescos
      this.debounceBuscarRegistroPorCriterios()
    },

    onLupaChange() {
      if (this.busquedaFin) return
      // Ejecutar función para buscar registro por criterios
      this.debounceBuscarRegistroPorCriterios()
    },

    debounceBuscarRegistroPorCriterios: debounce(async function () {
      await this.buscarRegistroPorCriterios()
    }, 1000),

    async buscarRegistroPorCriterios() {
      // Si la búsqueda inicial ya se completó, no hagas nada más.
      if (this.busquedaFin) {
        return
      }

      if (
        !this.registro.id_finca ||
        !this.registro.id_parcela ||
        !this.registro.fecha
      ) {
        this.limpiarMensaje()
        return
      }
      this.buscandoRegistro = true
      //this.limpiarMensaje()
      try {
        const registroExistente = this.buscarRegistroLocal()
        if (registroExistente) {
          await this.traerRegistroYNavegar(registroExistente)
        } else {
          // Si no está en local, buscar en servidor
          await this.buscarRegistroEnServidor()
        }
      } catch (error) {
        this.registroNoEncontrado()
      } finally {
        this.buscandoRegistro = false
        this.busquedaFin = true
      }
    },
    buscarRegistroLocal() {
      // Buscar en el store de forestales
      //alert('pase por local')
      const avicolas = this.$store.state.registros.avicolas
      return Object.values(avicolas).find(
        (avicolas) =>
          avicolas.id_finca === this.registro.id_finca &&
          avicolas.id_parcela === this.registro.id_parcela &&
          avicolas.fecha === this.registro.fecha
      )
    },
    async buscarRegistroEnServidor() {
      try {
        //console.log(this.registro.id_productor)
        const response = await this.$store.dispatch(
          'registros/listarAvicolasx',
          {
            id_productor: this.registro.id_productor,
            id_finca: this.registro.id_finca,
            id_parcela: this.registro.id_parcela,
            fecha: this.registro.fecha,
          }
        )

        if (response && response.success && Array.isArray(response.data)) {
          const fechaBuscada = this.registro.fecha
          const registroExacto = response.data.find((r) => {
            const fechaApi = r.fecha ? r.fecha.split('T')[0] : null
            return fechaApi === fechaBuscada
          })

          if (registroExacto) {
            await this.traerRegistroYNavegar(registroExacto)
          } else {
            this.registroNoEncontrado()
          }
        } else {
          this.registroNoEncontrado()
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          this.registroNoEncontrado()
        } else {
          throw error
        }
      }
    },

    async traerRegistroYNavegar(registro) {
      if (registro.sincronizado === true) {
        await this.$store.dispatch('registros/getAvicola', { id: registro.id })
      }
      this.$router.push(`/ru/avicola/${registro.id}`)
      this.esEditable = false
      this.busquedaFin = true
    },

    mostrarMensaje(mensaje, tipo) {
      this.mensajeBusqueda = mensaje
      this.tipoMensaje = tipo
    },

    limpiarMensaje() {
      this.mensajeBusqueda = ''
      this.tipoMensaje = 'info'
    },
    descripcionActividad(id) {
      const act = this.actividad_avicola.find((a) => a.id === id)
      return act ? act.descripcion : 'Desconocido'
    },
    agregarProduccionYEditar() {
      this.registro.producciones.unshift(clona(this.registro_produccion))
      this.registro.id_productor = this.productor_actual
      this.indexEdicion = 0
      this.$nextTick(() => {
        if (
          this.$refs.tipoavicolaSelect &&
          this.$refs.tipoavicolaSelect.focus
        ) {
          this.$refs.tipoavicolaSelect.focus()
        }
      })
    },
    AgregarEngorde() {
      //console.log('Agregando engorde', this.registro.reg_avicola)

      if (!Array.isArray(this.registro.reg_avicola)) {
        this.registro.reg_avicola = []
      }
      this.registro.reg_avicola.unshift(clona(this.reg_avicola))
      this.$nextTick(() => {
        this.indexEdicionEngorde = 0
      })
      this.registro.id_productor = this.productor_actual
    },
    editarProduccion(index) {
      this.indexEdicion = index
    },
    guardarEntrada() {
      this.indexEdicion = null
    },
    convertirDatosSexo() {
      if (this.registro.producciones) {
        this.registro.producciones.forEach((produccion) => {
          // Convertir número a string para que coincida con los values del select
          if (produccion.sexo !== null && produccion.sexo !== undefined) {
            produccion.sexo = produccion.sexo.toString()
          }
        })
      }
    },
    validarFechaNac() {
      const fechaNac = this.registro.producciones[this.indexEdicion].fechanac

      if (!fechaNac) {
        this.$set(this.errorn, `fechanac_${this.indexEdicion}`, '')
        return true
      }

      const regexFecha = /^(\d{4})-(\d{2})-(\d{2})$/ // formato correcto: aaaa-mm-dd
      if (!regexFecha.test(fechaNac)) {
        this.$set(
          this.errorn,
          `fechanac_${this.indexEdicion}`,
          'Formato: aaaa-mm-dd'
        )
        return false
      }

      const [, anio, mes, dia] = fechaNac.match(regexFecha)
      const diaInt = parseInt(dia, 10)
      const mesInt = parseInt(mes, 10)
      const anioInt = parseInt(anio, 10)

      if (mesInt < 1 || mesInt > 12) {
        this.$set(
          this.errorn,
          `fechanac_${this.indexEdicion}`,
          'El mes debe estar entre 01 y 12.'
        )
        return false
      }

      const diasEnMes = new Date(anioInt, mesInt, 0).getDate()
      //console.log('GATE 8')
      if (diaInt < 1 || diaInt > diasEnMes) {
        //console.log('GATE 9')
        this.$set(
          this.errorn,
          `fechanac_${this.indexEdicion}`,
          'El día no es válido para ese mes.'
        )
        return false
      }
      //console.log('GATE 10')

      this.$set(this.errorn, `fechanac_${this.indexEdicion}`, '')
      return true
    },
    //////////   DRAGON ///////////////
    mostrarFormularioEdicion(index) {
      const item = this.registro.producciones[index]
      // Hacemos una copia editable para no afectar en tiempo real la tabla
      this.filaEdicion = { ...item }
      this.filaVisibleIndex = index
      this.mostrarFormularioEditable = true
    },
    ocultarFormulario() {
      // DRAGON Guarda los cambios en la tabla original
      if (this.filaVisibleIndex !== null) {
        this.$set(this.registro.producciones, this.filaVisibleIndex, {
          ...this.filaEdicion,
        })
      }
      this.filaVisibleIndex = null
      this.mostrarFormularioEditable = false
      this.filaEdicion = null
    },
    /////////////////////
    aplicarFiltro(produccion) {
      // Actualiza los criterios de filtro
      this.filtro.id_actividad_pecuaria = produccion.id_actividad_pecuaria
      this.filtro.identirubro = produccion.identirubro
    },
    limpiarDestinosYGuardar() {
      // Verificar si algún destino tiene el campo 'rubro' vacío
      const destinosConRubroVacio = this.registro.destinos.filter(
        (destino) => !destino.rubro
      )
      // Si hay destinos con el campo 'rubro' vacío
      if (destinosConRubroVacio.length > 0) {
        // Mostrar una alerta (por ejemplo con v-snackbar o alert, dependiendo de lo que prefieras)
        this.snackbarMessage =
          'Es requerido cerrar la venta si no se está incluyendo venta válida.'
        this.snackbarVisible = true
      } else {
        // Filtrar destinos con rubro lleno
        this.registro.destinos = this.registro.destinos.filter(
          (destino) => destino.rubro
        )
      }
      //console.log('Registro limpio:', this.registro)
    },
    /*  manejarIngreso() {
    this.mostrarInventario = true
    this.mostrarProduccion = false
    this.mostrarEngorde = false
    this.mostrarVenta = false
    const formularioVacio = this.registro.producciones.find(p => 
      !p.id_actividad_pecuaria || 
      p.id_actividad_pecuaria === '' || 
      p.id_actividad_pecuaria === null
    )
    if (formularioVacio) {
      this.indexEdicion = this.registro.producciones.indexOf(formularioVacio)
    }
     else {
    this.agregarProduccionYEditar();
    this.indexEdicion = this.registro.producciones.length - 1;
    }
  }, */
    /* manejarEngorde() {
    this.mostrarInventario = false
    this.mostrarProduccion = false
    this.mostrarEngorde = true
    this.mostrarVenta = false
    const formularioVacio = this.registro.reg_avicola.find(p => 
      !p.id_actividad_pecuaria || 
      p.id_actividad_pecuaria === '' || 
      p.id_actividad_pecuaria === null
    )
    if (formularioVacio) {
      this.indexEdicionEngorde = this.registro.reg_avicola.indexOf(formularioVacio)
    }
    else {
    this.AgregarEngorde();
    this.indexEdicionEngorde = this.registro.reg_avicola.length - 1;
    }
  }, */
    /* manejarVenta() {
    this.mostrarInventario = false
    this.mostrarProduccion = false
    this.mostrarEngorde = false
    this.mostrarVenta = true
    const formularioVacio = this.registro.destinos.find(p => 
      !p.rubro || 
      p.rubro === '' || 
      p.rubro === null
    )
    if (formularioVacio) {
      this.indexEdicionVenta = this.registro.destinos.indexOf(formularioVacio)
    }
  }, */
    pmostrarInventario() {
      this.mostrarInventario = true
      this.mostrarEngorde = false
      this.mostrarVenta = false
      this.activeTab = 'ingreso'
    },
    pmostrarEngorde() {
      this.mostrarInventario = false
      this.mostrarEngorde = true
      this.mostrarVenta = false
      this.activeTab = 'engorde'
    },
    pmostrarVenta() {
      this.mostrarInventario = false
      this.mostrarEngorde = false
      this.mostrarVenta = true
      this.activeTab = 'venta'
    },

    inicializarProducciones() {
      if (this.registro.producciones.length < 1) {
        while (this.registro.producciones.length < 1) {
          this.addRow()
        }
      }

      if (this.registro.reg_avicola.length < 1) {
        while (this.registro.reg_avicola.length < 1) {
          this.AgregarEngorde()
        }
      }
      // Asegurar que todos los registros tengan datos o asignarlos vacios si no existen
      this.registro.producciones = this.registro.producciones.map(
        (produccion) => ({
          ...produccion,
          ingreso_anual:
            typeof produccion.ingreso_anual !== 'undefined'
              ? produccion.ingreso_anual
              : '0',
          estatus: produccion.estatus || 'A',
          identirubro: produccion.identirubro || '0',
          haespecia: produccion.haespecia || '',
          ugequivalente: produccion.ugequivalente || '',
          unidad: produccion.unidad || '',
        })
      )
    },
    addRow() {
      this.registro.producciones.push({
        id_actividad_pecuaria: '',
        identirubro: '0',
        // fechanac: '',
        color: '',
        // raza: '',
        cantidad: '',
        produccion: '',
        ugsumespecie: '',
        ingreso_anual: 0,
        unidad: '',
        ugequivalente: '',
        estatus: '',
      })
    },
    /*    AgregarEngorde() {
      const nuevoEngorde = {
        id_actividad_pecuaria: '',
    id_pecuario: this.registro.id || null,
    identirubro: '0',
    fecha_medicion: new Date().toISOString().split('T')[0], // Fecha actual
    medicion: '0',
    cantidad: 0,
    id_medicion: '',
    unidad: '',
    etapa_anterior: '',
    etapa_actual: '',
      }
      this.registro.reg_avicola.unshift(nuevoEngorde) 
      this.$nextTick(() => {
        this.indexEdicionEngorde = 0 
      })
    },
   */
    editarEngorde(index) {
      this.indexEdicionEngorde = index
    },
    guardarEngorde() {
      this.indexEdicionEngorde = null
    },
    esEntradaValida(item) {
      return item.id_actividad_pecuaria
    },
    esEngordeValido(fila) {
      return fila.id_actividad_pecuaria && fila.fecha_medicion
    },
    esDestinoValido(destino) {
      return destino.rubro
    },

    descripcionUnidad(idUnidad) {
      const unidad = this.unidad_medida.find((u) => u.id === idUnidad)
      return unidad ? unidad.descripcion : ''
    },

    handleAddRowAndOtherAction() {
      this.AgregarEngorde()
    },

    setFechaInicio() {
      const today = new Date()
      const dia = today.getDate().toString().padStart(2, '0')
      const mes = (today.getMonth() + 1).toString().padStart(2, '0') // getMonth() es 0-indexado
      const anio = today.getFullYear()
      this.registro.fecha = `${dia}-${mes}-${anio}`
    },

    validarFecha() {
      const regexFecha = /^(\d{4})-(\d{2})-(\d{2})$/ // formato aaaa-mm-dd
      const fecha = this.registro.fecha

      if (!regexFecha.test(fecha)) {
        this.errorin =
          'Favor colocar la fecha en el formato correcto: aaaa-mm-dd'
        return false
      }

      const [, anio, mes, dia] = fecha.match(regexFecha)
      const diaInt = parseInt(dia, 10)
      const mesInt = parseInt(mes, 10)
      const anioInt = parseInt(anio, 10)

      // 3 Validar año lógico
      const anioActual = new Date().getFullYear()
      if (anioInt < 1900 || anioInt > anioActual + 1) {
        this.errorin = `El año debe estar entre 1900 y ${anioActual + 1}.`
        return false
      }

      if (mesInt < 1 || mesInt > 12) {
        this.errorin = 'El mes debe estar en el rango de 1 a 12.'
        return false
      }

      const diasEnMes = new Date(anioInt, mesInt, 0).getDate()
      if (diaInt < 1 || diaInt > diasEnMes) {
        this.errorin = `El día no es válido para el mes ${mesInt} y año ${anioInt}.`
        return false
      }

      // Validación de fecha real (extra por si acaso)
      const fechaObj = new Date(`${anioInt}-${mesInt}-${diaInt}`)
      if (isNaN(fechaObj.getTime())) {
        this.errorin = 'La fecha no es válida.'
        return false
      }

      this.errorin = '' // Todo bien
      return true
    },
    validarFechaSalida(index) {
      const fechaSalida = this.registro.producciones[index].salida

      if (!fechaSalida) {
        this.$set(this.errors, `salida_${index}`, '')
        return true
      }

      const regexFecha = /^(\d{4})-(\d{2})-(\d{2})$/ // aaaa-mm-dd

      if (!regexFecha.test(fechaSalida)) {
        this.$set(this.errors, `salida_${index}`, 'Formato: aaaa-mm-dd')
        return false
      }

      const [, anio, mes, dia] = fechaSalida.match(regexFecha)
      const diaInt = parseInt(dia, 10)
      const mesInt = parseInt(mes, 10)
      const anioInt = parseInt(anio, 10)

      if (mesInt < 1 || mesInt > 12) {
        this.$set(
          this.errors,
          `salida_${index}`,
          'El mes debe estar entre 01 y 12.'
        )
        return false
      }

      const diasEnMes = new Date(anioInt, mesInt, 0).getDate()
      if (diaInt < 1 || diaInt > diasEnMes) {
        this.$set(
          this.errors,
          `salida_${index}`,
          'El día no es válido para ese mes.'
        )
        return false
      }

      this.$set(this.errors, `salida_${index}`, '')
      return true
    },
    validarfechareg(valor) {
      let regexFecha = /^(\d{4})-(\d{2})-(\d{2})$/
      if (!regexFecha.test(valor)) {
        this.erroreg =
          'Favor colocar año, mes y día separado con guiones así: aaaa-mm-dd'
        return
      }
      let [, anio, mes, dia] = valor.match(regexFecha)
      if (parseInt(mes) < 1 || parseInt(mes) > 12) {
        this.errorreg = 'El mes debe estar en el rango de 1 a 12.'
        return
      }
      let diasEnMes = new Date(anio, mes, 0).getDate()
      if (parseInt(dia) < 1 || parseInt(dia) > diasEnMes) {
        this.errorreg = 'El día no es válido para el mes especificado.'
        return
      }
      this.errorreg = ''
    },
    //función que formatea la fecha para enviarla a la BD
    formatearFechaParaBD(fechaDDMMYYYY) {
      const regex = /^(\d{2})-(\d{2})-(\d{4})$/
      if (!regex.test(fechaDDMMYYYY)) return fechaDDMMYYYY
      const [, dia, mes, anio] = fechaDDMMYYYY.match(regex)
      return `${anio}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    //Función que formatea la fecha que que se trae de la BD para mostrarla en el front
    formatearFechaParaFormulario(fechaYYYYMMDD) {
      const regex = /^(\d{4})-(\d{2})-(\d{2})$/
      if (!regex.test(fechaYYYYMMDD)) return fechaYYYYMMDD
      const [, anio, mes, dia] = fechaYYYYMMDD.match(regex)
      return `${dia}-${mes}-${anio}`
    },

    limpiarRegistrosVacios() {
      /* this.registro.producciones = this.registro.producciones.filter(item => this.esEntradaValida(item))
      this.registro.reg_avicola = this.registro.reg_avicola.filter(item => this.esEngordeValido(item)) */
      this.registro.producciones = this.registro.producciones.filter((item) =>
        this.esEntradaValida(item)
      )

      this.registro.destinos = (this.registro.destinos || []).filter((item) =>
        this.esDestinoValido(item)
      )
      this.$nextTick(() => {})
    },
    //JUANDIEGO
    async antesDeGuardar() {
      // Limpiar registros vacíos
      //console.log('antes de payload', this.registro)

      const payload = { ...this.registro }

      if (!payload.id_finca || !payload.id_parcela || !payload.fecha) {
        this.$store.commit('ui/setSnack', {
          text: 'Antes de guardar debe llenar Finca, Galera y Fecha antes de guardar',
          color: 'error',
        })
        return
      }
      this.limpiarRegistrosVacios()
      //Esperar a que termine la limpieza
      await this.$nextTick()

      //console.log('despues de limpiar', this.registro)
      // Validación mínima en el front antes de enviar

      // Formatear fechas
      /*  this.registro.fecha = this.formatearFechaParaBD(this.registro.fecha)
        this.registro.producciones.forEach((produccion, index) => {
          produccion.salida = this.formatearFechaParaBD(produccion.salida)
          produccion.fechanac = this.formatearFechaParaBD(produccion.fechanac) 
        }) 
         await this.$nextTick()*/
      // exvita navegacion redundante
      if (this.$route.path === `/ru/${this.ruta_registros}`) {
        this.ruta_registros = ''
      }
      this.guardarYContinuar()
    },

    esEntradaValida(item) {
      return item.id_actividad_pecuaria
    },

    esDestinoValido(destino) {
      return destino.rubro
    },

    calcularDuracionProduccion() {
      const fecha = new Date(this.registro.fecha)
      const fecha_fin = new Date(this.registro.fecha_fin)

      if (!isNaN(fecha) && !isNaN(fecha_fin)) {
        const aniosDiferencia = fecha_fin.getFullYear() - fecha.getFullYear()
        const mesesDiferencia = fecha_fin.getMonth() - fecha.getMonth()
        this.registro.duracionProduccion =
          aniosDiferencia * 12 + mesesDiferencia
      } else {
        this.registro.duracionProduccion = 0 // Si alguna fecha no es válida, asigna 0
      }
    },

    isDiagnosticoPecuario(id_cultivo) {
      return (
        this.getRubroById(id_cultivo)?.clasificacion === 'ADIAGNOSTICO PECUARIO'
      )
    },

    //no se usa
    getRubroById(id_cultivo) {
      return this.actividad_pecuaria.find((ap) => ap.id === id_cultivo)
    },

    calculatePastoSurfaceAndWarn() {
      let surfaceSum = 0
      for (const prod of this.registro?.producciones) {
        // calcula que la suma de superfices no exceda la del formulario
        if (!isNaN(parseFloat(prod.haespecia)) && prod.haespecia > 0) {
          surfaceSum += parseFloat(prod.haespecia)
        }

        this.pastoSurfaceOverflow =
          surfaceSum > this.registro.superficie_para_pasto ? true : false
      }
    },

    guessUnit(id_rubro) {
      const rubro = this.actividad_pecuaria.find((a) => a.id === id_rubro)
      return this.unidadMedidaPorId(rubro?.id_unidad_medida ?? 2)
    },

    handleActividadChange(indice) {
      if (indice === undefined || indice === null) return

      const rubro = this.actividad_pecuaria.find(
        (a) => a.id === this.registro.producciones[indice].id_actividad_pecuaria
      )

      if (this.registro.producciones[indice].id_actividad_pecuaria) {
        if (!this.registro.producciones[indice].identirubro) {
          this.registro.producciones[indice].identirubro = 0
        }

        this.registro.producciones[indice].unidad =
          rubro?.id_unidad_medida ?? null
        this.registro.producciones[indice].ugequivalente = 0
        this.registro.producciones[indice].ugsumespecie = 0
        this.registro.producciones[indice].produccion = 0
        this.registro.producciones[indice].cantidad = 0
        this.registro.producciones[indice].haespecia = 0
        this.registro.producciones[indice].ingreso_anual = 0
        this.registro.estatus = 'A'
      }
    },
    async obtenerUnRegistroONada() {
      try {
        const id_productor = this.registro.id_productor
        const ciclo = this.registro.ciclo
        const fecha = this.registro.fecha
        const id_finca = this.registro.id_finca
        const id_parcela = this.registro.id_parcela
        const id_rubros = !this.obtenerIdDeRuta()
          ? this.registro.producciones
              .filter((prod) => !!prod.id_actividad_pecuaria)
              .map((prod) => prod.id_actividad_pecuaria)
          : []

        if (id_rubros.length === 0) {
          id_rubros = []
        }

        const rubros =
          (!this.obtenerIdDeRuta() && id_rubros.length > 0) ||
          this.obtenerIdDeRuta()

        //console.log(this.registro.id_productor)

        // required fields to be fulfilled
        if (fecha && id_finca && rubros) {
          const { status, data } = await this.$store.dispatch(
            'registros/listarAvicolasx',
            {
              id_productor,
              ciclo,
              fecha,
              id_finca,
              id_parcela,
              id_rubros,
            }
          )
          if (status === 'ok' && data.length > 0) return data[0]
        }
        return {}
      } catch (e) {
        return {}
      }
    },
    Cancelar() {
      this.$router.push('/ru/avicolas')
    },
    agregarDesastre() {
      this.registro.desastres?.push({ ...danotrx })
    },
    eliminarDesastre(index) {
      this.registro.desastres?.splice(index, 1)
    },
    eliminarFilaProduccion(index) {
      this.registro.producciones.splice(index, 1)
      if (this.indexEdicion === index) {
        this.indexEdicion = null
      } else if (this.indexEdicion > index) {
        this.indexEdicion--
      }
    },
    eliminarFilaEngorde(index) {
      this.registro.reg_avicola.splice(index, 1)
      this.indexEdicionEngorde = null
    },
  },
}
</script>
<style scoped>
/* .overflow-container {
  overflow-x: auto;
  width: 100%;
  margin: 0 auto;
  /* max-width: 100%;
} */
.btn-oval {
  border-radius: 50px; /* Hace que el botón sea más ovalado */
}
.btn-final {
  display: flex;
}
.cancel {
  background-color: red !important;
  color: white !important;
}

.error-text {
  color: red;
  font-size: 0.875rem;
}

.button-row td {
  border: none;
  padding: 0;
  text-align: center;
}

.button-row {
  margin: 16px 0;
  /* Agrega espacio alrededor */
}

.custom-table {
  min-width: 500px;
  width: 100%;
  border-collapse: collapse;
}

.custom-table th,
.custom-table td {
  padding: 8px;
  text-align: left;
  border: 1px solid #ccc;
}

.custom-table th.header {
  font-size: 15px;
}
.custom-table th {
  background-color: #050505ef;
  text-align: center;
  color: #fff;
}

.custom-table1 {
  min-width: 500px;
  width: 100%;
  border-collapse: collapse;
}

.custom-table1 th,
.custom-table1 td {
  text-align: center;
  border: 1px solid #ccc;
  padding: 8px;
}

@media (max-width: 768px) {
  .custom-table1 th,
  .custom-table1 td {
    font-size: 12px; /* Reducir tamaño de fuente */
  }
}

.custom-table1 th.headera {
  font-size: 15px;
}

.custom-table1 th {
  background-color: #050505ef;
  text-align: center;
  color: #fff;
}

.table-container {
  overflow-y: auto;
  overflow-x: auto;
  width: 100%;
  height: auto;
}

.elevation-1 {
  max-width: 100%;
  /* Asegura que el contenedor de la tabla se expanda completamente */
  /* overflow-x: auto; */
  /* Permite que la tabla sea desplazable si es más ancha que su contenedor */
}

/* .btn-primary {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 3px;
  padding: 2px 8px;
  cursor: pointer;
  transition: background-color 0.3s;
} */

/* .btn-primary:hover {
  background-color: #0056b3;
} */

/* .btn-secondary {
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 2px 12px;
  cursor: pointer;
  transition: background-color 0.3s;
} */

/* .btn-secondary:hover {
  background-color: #5a6268;
} */

.production-field {
  display: flex;
  align-items: center;
}

.production-field .v-input__control {
  display: flex;
  align-items: center;
}

.production-field .v-input__control > * {
  margin-right: 4px;
}
.flex-nowrap {
  flex-wrap: nowrap !important;
}
</style>